import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const FormContainer = styled.div`
	background-color: var(--white);
	padding: 1rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	border: none;

	@media ${Breakpoints.mobile} {
		padding: var(--padding-2) var(--padding-3);
	}

	.form-row-container {
		.formitem-column {
			flex-direction: row;
			gap: 2rem;
			align-items: center;
		}
	}
	.pre-text {
		font-family: inherit;
		margin: 0;
		white-space: break-spaces;
		word-break: break-all;
	}
	.json-text-area {
		max-width: 100%;
		min-width: 100%;
		max-height: 30rem;
		min-height: 4.5rem;
	}
	.copy-button {
		background: transparent;
		border: none;
	}
`;

export const FormArea = styled.div`
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	width: 100%;
	padding-bottom: var(--padding-2);
	&::after {
		content: '';
		height: 1px;
		background-color: var(--border-color);
	}
`;
